<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Network Pelanggan</h4>
                    <p class="card-category">Berikut ini Jaringan network pelanggan</p>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="command col-md-6">
                    <div class="form-group" v-show="false">
                      <input type="text" class="form-control" placeholder="Cari..." style="width:100%" v-model="nama" />
                      <button class="btn btn-info" @click="cari()">Cari</button>
                    </div>
                  </div>
                  <div class="command col-md-6 text-right">
                      <button class="btn btn-info" @click="zoom(1)">ZoomIn</button>
                      <button class="btn btn-success" @click="zoom(-1)">ZoomOut</button>
                  </div>
                </div>
                <div style="overflow: hidden;height: 500px;">
                  <div id="panzoom-element">
                    <TreeChart :json="treeData" @click-node="clickNode"/>
                  </div>
                </div>
                <div class="info">
                  <p class="mb-0">Terpilih : </p>
                  <p class="mb-0">{{nama}}</p>
                  <p class="mb-0">{{telepon}}</p>
                </div>
              </div>
            </div>
          </div>
          
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import inter from '@/globalFunc/Interface' 
import TreeChart from "vue-tree-chart";
import Panzoom from '@panzoom/panzoom'

export default {
  name: 'Beranda', 
  components: { 
    TreeChart
  },
  props: {
    options: {type: Object, default: () => {}},
  },
  data () {
    return {
      treeData: '',
      nama: '',
      telepon: ''
    }
  },
  methods: {
    Simpan() {
      /*
      var data = new FormData();

      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idPaket);
      data.append('nama', this.namaPaket);
      data.append('tarif', this.tarifPaket);
      data.append('keterangan', this.keteranganPaket);
      */
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        id: this.idPaket,
        nama: this.namaPaket,
        tarif: this.tarifPaket,
        keterangan: this.keteranganPaket
      }
      
      var apiUrl = inter.EditPaket(); // EditTarif
      this.PostData(data,apiUrl).then(x => {
        if (x.status == true) {
          this.modalEdit = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    cari() {

    },
    getData() {
      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken')
      }
      
      var apiUrl = inter.ListNetwork();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x.data));
        if (x.status == true) {
          this.treeData = {
            name: 'Server',
            image_url: "https://admin.beatcom.web.id/mikrotik.png",
            class: ["rootNode"],
            children: x.data
            };
        } else {
          //alert(x.pesan);
        }
      })
    },
    zoom(level){
      level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
    },
    clickNode: function(node){
      // eslint-disable-next-line
      //console.log(JSON.stringify(node.wa))
      this.nama = node.name;
      this.telepon = node.wa;
    }
  },
  mounted () {
    document.title = "Network Chart Pelanggan";
    this.getData();
    
    this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
        maxScale: 5
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/network/main.vue